import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_without_properties } from "@swc/helpers/_/_object_without_properties";
import React from 'react';
import BrandedButton from '../../../../../Buttons/BrandedButton';
const ConfirmButton = (_param)=>/*#__PURE__*/ {
    var { children } = _param, rest = _object_without_properties(_param, [
        "children"
    ]);
    return React.createElement(BrandedButton, _object_spread({
        size: "large",
        variant: "brand-green"
    }, rest), children);
};
ConfirmButton.displayName = 'ConfirmButton';
export default ConfirmButton;
